import { FaBoxOpen, FaCreditCard, FaDatabase, FaFileInvoiceDollar, FaGear, FaHexagonNodes, FaHouse, FaLifeRing, FaMoneyBillWave, FaUserGear, FaUsers, FaUserTie, FaWhatsapp, FaWifi } from "react-icons/fa6";

export const NavLinkItemOwnerApp = [
  { name: "Dashboard", icon: FaHouse, path: "/dashboard-menu", type: "link" },
  { name: "Pelanggan", icon: FaUserTie, path: "/dashboard/customer", type: "link" },
  {
    name: "Paket", icon: FaHexagonNodes, type: "accordion",
    subItems: [
      { name: "Daftar Paket", path: "/dashboard/invoice/list" },
      { name: "Fitur Paket", path: "/dashboard/invoice/promise-to-pay" },
    ],
  },
  {
    name: "Invoice", icon: FaBoxOpen, type: "accordion",
    subItems: [
      { name: "List", path: "/dashboard/invoice/list" },
      { name: "Janji Bayar", path: "/dashboard/invoice/promise-to-pay" },
    ],
  },
  {
    name: "WhatsApp", icon: FaWhatsapp, type: "accordion",
    subItems: [
      { name: "Pesan Wa", path: "/dashboard/whatsapp/message" },
      { name: "No Whatsapp", path: "/dashboard/whatsapp/number" },
      { name: "Template Pesan", path: "/dashboard/whatsapp/template" },
    ],
  },
  
  { name: "Payment Gateway", icon: FaCreditCard, path: "/dashboard/payment-gateway", type: "link" },
  { name: "Pengguna", icon: FaUserGear, path: "/dashboard/user-manager", type: "link" },
  { name: "Keuangan", icon: FaMoneyBillWave, path: "/dashboard/finance", type: "link" },
  { name: "Pengaturan", icon: FaGear, path: "/dashboard/setting", type: "link" },
];